import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {SelectItem} from 'primeng/api';
import {Repository} from '@app/@core/repositories/repository';
import {TicketModel} from '@app/models/ticket';
import Ticket = TicketModel.Ticket;
import {orderBy} from 'lodash-es';
import {CourseOption} from '@app/@core/repositories/course.repository';

export interface TicketOption {
    label: string;
    value: string;
    status: 'OPEN' | 'CLOSE';
}

@Injectable({
    providedIn: 'root'
})
export class TicketRepository extends Repository<Ticket> {
    private ticketSelectItems: TicketSelectItem[];


    constructor(http: HttpClient) {
        super(http, 'ticket');
    }

    fetchTicketWithItems(ticketId: string): Observable<Ticket> {
        return this.http.get<any>(`${this.entityUrl}/${ticketId}/items`).pipe(map(rs => rs.model));
    }

    getSelectItems(): Observable<TicketSelectItem[]> {
        if (this.ticketSelectItems) {
            return of(this.ticketSelectItems);
        }

        return this.http.get<any[]>(`${this.entityUrl}/names`).pipe(
            map((list: any[]) => {
                list = orderBy(list, 'name');
                this.ticketSelectItems = list.map(v => ({value: v.id, label: v.name, status: v.status}));
                return this.ticketSelectItems;
            })
        );
    }

    fetchNames(): Observable<TicketOption[]> {
        return this.http.get<any[]>(`${this.entityUrl}/names`).pipe(
            map( list => list.map( m => ({
                value: m.id,
                label: m.name,
                status: m.status
            }))),
            map(list => orderBy((list), 'label'))
        );
    }

    getStatusList(): Observable<SelectItem[]> {
        const statusList: SelectItem[] = [
            {label: 'CREATE', value: 'CREATE'},
            {label: 'CANCEL', value: 'CANCEL'},
            {label: 'PAID', value: 'PAID'},
            {label: 'CANCEL_PAID', value: 'CANCEL_PAID'},
            {label: 'TIMEOUT', value: 'TIMEOUT'},
            {label: 'FINISH', value: 'FINISH'}
        ];

        return of(statusList);
    }


    getItemStatus(): string[] {
        return ['SALE', 'SOLD_OUT', 'HIDE'];
    }

    saveItemAvailable(itemId: string, stockAdd: number, availableAdd: number, status: string): Observable<any> {
        const params = {stockAdd, availableAdd, status};
        return of({success: true});

        // return this.http.post<TicketNameResponse[]>(`${this.entityUrl}/items/${itemId}`, );
    }

    loadSchema(): Observable<any> {
        return this.http.get<any>('assets/schema.ticket.json');
    }
}

export interface TicketSearchParam {
    searchTerm: string;
    orderFromDate: string;
    orderToDate: string;
    status: string;
    ticketId: string;
}

export interface TicketSelectItem extends SelectItem {
    status?: string;
}
